import { Injectable } from '@angular/core';
import { BaseFpxDataService, CreateFn, CriteriaQuery, FindAllFn, FindByKeyFn, HttpProviderService, HttpRequest, LookUpFn, ModifyFn } from '@fpx/core';
import { Observable, of } from 'rxjs';
import { ProcessShellService } from 'src/app/process-shell/services/process-shell.service';
import { environment } from 'src/environments/environment';
import { DocInfo } from './documentupload.model';

@Injectable({
  providedIn: 'root'
})
export class DocumentUploadService implements BaseFpxDataService<any> {

  constructor(private _httpProvider : HttpProviderService,
    private _processShellService: ProcessShellService) { }
  findByKey(payload: any): FindByKeyFn<any> {
    throw new Error('Method not implemented.');
  }
  findAll(criteriaQuery: CriteriaQuery): FindAllFn<any> {
    throw new Error('Method not implemented.');
  }
  
  create(payload: DocInfo): CreateFn<any> {
    return () => of({});
  }

  lookup(key: unknown): LookUpFn<any> {
    throw new Error('Method not implemented.');
  }
  modify(payload: any): ModifyFn<any> {
    return () => {
      let processId = this._processShellService.processId;
      let docType = payload.docType;
      const httpRequest = new HttpRequest();
      httpRequest.setMethod('PUT');
      httpRequest.setResource(`/docinfo/${processId}/${docType}`);
      delete payload.docType;
      let bodyContent = {"docinfo":payload};
      httpRequest.setBody(bodyContent);
      httpRequest.setServerContext(environment.commonPublisher);
      return this._httpProvider.invokeRestApi(httpRequest);
    };
  }

  fetchDetails(payload: any):Observable<any>{
    const httpRequest = new HttpRequest();
    httpRequest.setMethod('POST');
    httpRequest.setResource('/ob/upload/documents');
    httpRequest.addHeaderParamter('Content-Type','multipart/form-data');
    httpRequest.addQueryParameter('processId', payload.appRef);
    httpRequest.addQueryParameter('documentType', payload.documentType);
    let bodyContent = payload.formData;
    httpRequest.setBody(bodyContent);
    httpRequest.setServerContext(environment.commonPublisher);
    return this._httpProvider.invokeRestApi(httpRequest);
  }

  fetchDocContent(docType: any):Observable<any> {
      let processId = this._processShellService.processId;
      const httpRequest = new HttpRequest();
      httpRequest.setMethod('GET');
      httpRequest.setResource(`/doccontent/${processId}/${docType}`);
      httpRequest.setServerContext(environment.commonPublisher);
      return this._httpProvider.invokeRestApi(httpRequest);
  }

  docInfo(payload: any): Observable<any> {
      let processId = this._processShellService.processId;
      let docType = payload.docType;
      const httpRequest = new HttpRequest();
      httpRequest.setMethod('PUT');
      httpRequest.setResource(`/docinfo/${processId}/${docType}`);
      delete payload.docType;
      let bodyContent = {"docinfo":payload};
      httpRequest.setBody(bodyContent);
      httpRequest.setServerContext(environment.commonPublisher);
      return this._httpProvider.invokeRestApi(httpRequest);
  }
}
